module.exports = __webpack_public_path__ + "img/bj51.55b840ea.png";